import gql from 'graphql-tag';
import {
  placeInterlockableFragment,
  towerCamerasFragment,
  towerFragment,
} from './fragments';

export const towerPlaces = gql`
  query towerPlaces($condominiumId: Int!) {
    towerPlaces(condominiumId: $condominiumId) {
      ...placeInterlockablePartsForTower
    }
  }
  ${placeInterlockableFragment}
`;

export const towerDvrCameras = gql`
  query towerDvrCameras($placeId: Int!) {
    towerDvrCameras(placeId: $placeId) {
      ...towerCamerasPart
    }
  }
  ${towerCamerasFragment}
`;

export const listCondominiumTowers = gql`
  query listCondominiumTowers($condominiumId: Int!) {
    listCondominiumTowers(condominiumId: $condominiumId) {
      ...towerPart
    }
  }
  ${towerFragment}
`;
